
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/news/press-releases/item/[slug]",
      function () {
        return require("private-next-pages/[locale]/news/press-releases/item/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/news/press-releases/item/[slug]"])
      });
    }
  